







import {apiV1AdminAdvicePath, apiV1AdminAdvicesPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostNew from '@/components/admin/PostNew'
import AddinForm from '@/components/admin/advices/AddinForm.vue'
import Post, {IPost} from '@/models/Post'
import Advice, {IAdvice} from '@/models/Advice'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm,
    AddinForm
  }
})
export default class AdviceNew extends PostNew {
  path = 'advices'
  createPath = apiV1AdminAdvicesPath()

  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminAdvicePath('new')
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new Advice(data as IAdvice)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '沖縄移住相談室一覧',
        to: '/admin/advices',
        exact: true
      },
      {
        text: '沖縄移住相談室新規作成'
      }
    ]
  }
}
